var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isTyres)?_c('TheAutoTyreSidebarFilter'):(_vm.isWheels)?_c('TheAutoWheelSidebarFilter'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }